import { memo } from 'react';
import styled from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { getFromNumberDescription } from 'calling-ui-library/utils/phoneNumberSourceUtils';
import { DropdownMenuOption } from 'foundations-components/transitional/components/Dropdown';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import getIn from 'transmute/getIn';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledHoverDiv = styled.div.withConfig({
  displayName: "PhoneFromNumberOptionsWorkspace__StyledHoverDiv",
  componentId: "sc-1t1vy0a-0"
})(["&:hover{background-color:", ";}button[aria-disabled='true']{span *{color:", ";}}button{span *{justify-content:flex-start;width:100%;}}"], ({
  theme
}) => `${theme.color['fill-secondary-subtle']}`, ({
  theme
}) => theme.color['text-core-disabled']);
const StyledUIList = styled.div.withConfig({
  displayName: "PhoneFromNumberOptionsWorkspace__StyledUIList",
  componentId: "sc-1t1vy0a-1"
})(["overflow-y:auto;max-height:calc((5 + 0.5) * 40px);"]);
function PhoneFromNumberOptionsWorkspace({
  appIdentifier,
  channelAssignedPhoneNumbers,
  selectedFromNumber,
  onSelect
}) {
  return /*#__PURE__*/_jsx(StyledUIList, {
    "data-selenium-test": `section-options-list`,
    children: channelAssignedPhoneNumbers.map(fromNumberOption => {
      let Message = null;
      const fromNumberString = fromNumberOption.get('friendlyName') || '';
      const fromNumberValue = fromNumberOption.phoneNumber || '';
      const fromNumberExtension = fromNumberOption.extension || '';
      const selected = fromNumberString === getIn(['friendlyName'], selectedFromNumber);
      Message = fromNumberOption.nickname ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          children: fromNumberOption.nickname
        }), /*#__PURE__*/_jsxs(Text, {
          as: "small",
          display: "block",
          children: [/*#__PURE__*/_jsx(FormattedPhoneNumber, {
            value: fromNumberValue,
            extension: fromNumberExtension
          }), ' ', "(", getFromNumberDescription(fromNumberOption.source), ")"]
        })]
      }) : /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(FormattedPhoneNumber, {
          value: fromNumberValue,
          extension: fromNumberExtension
        })
      });
      return /*#__PURE__*/_jsx(StyledHoverDiv, {
        children: /*#__PURE__*/_jsx(Flex, {
          inlineSize: "100%",
          justifyContent: "space-between",
          children: /*#__PURE__*/_jsx(DropdownMenuOption, {
            selected: selected,
            onClick: () => onSelect(fromNumberOption),
            cursor: "pointer"
            /* @ts-expect-error dependent on trellis issue https://git.hubteam.com/HubSpot/foundations-components/issues/5685 */,
            use: "unstyled",
            padding: "300",
            inlineSize: "100%",
            "data-selenium-test": `pre-call-option-${fromNumberOption.phoneNumber}-${appIdentifier}`,
            children: Message
          }, fromNumberOption.phoneNumber)
        })
      }, fromNumberOption.phoneNumber);
    })
  });
}
export default /*#__PURE__*/memo(PhoneFromNumberOptionsWorkspace);